module.exports = __webpack_public_path__ + "static/media/Fingercross.497d3ae5.svg";